import { z } from 'zod';

export const registrationStepAboutAndTravelPlansSchema = z.object({
    about_me:
        z
            .string()
            .trim()
            .min(1, 'Описание обязательно')
            .max(255, 'Максимальная длина описания - 300 символов'),
    travel_plans:
        z
            .string()
            .min(1, 'Поле не должно быть пустым')
            .max(500, 'Описание слишком длинное'),
});

export type RegistrationStepAboutAndTravelPlansType = z.infer<typeof registrationStepAboutAndTravelPlansSchema>;
